import React, { Component } from 'react';
import Popover from 'material-ui/Popover';
import InfoIcon from 'material-ui/svg-icons/action/info';

import theme from '../../../muiTheme';

const styles = {
  unitInfoContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  infoIcon: {
    color: theme.palette.primary1Color,
    margin: '0 4px',
    height: '18px',
    width: '18px',
    cursor: 'pointer'
  },
  popoverDl: {
    fontSize: '0.833em',
    margin: '0.66em'
  },
  unitIdAlias: {
    fontWeight: 'bold',
    paddingRight: '4px'
  }
};

class UnitId extends Component {
  state = {
    open: false
  };

  unitIdAliasToFieldLookup = {
    // alias: field name
    Name: 'NAME',
    Type: 'UNITTYPE',
    Department: 'DEPARTMENT',
    Agency: 'AGENCY',
    Role: 'WILDLANDROLE',
    State: 'STATE',
    'GACC Unit ID': 'GACC'
  };

  handleClick = e => {
    e.preventDefault();

    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  renderPopoverText(unitIdAttributes) {
    if (!unitIdAttributes) {
      return <span style={styles.popoverDl}>Unit ID not found.</span>;
    }

    return (
      <table style={styles.popoverDl}>
        <tbody>
          {Object.keys(this.unitIdAliasToFieldLookup).map(alias => (
            <tr key={alias}>
              <td style={styles.unitIdAlias}>{alias}</td>
              <td>
                {unitIdAttributes[this.unitIdAliasToFieldLookup[alias]] ||
                  '\u2014'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    const { value, unitIdAttributes } = this.props;
    const { open, anchorEl } = this.state;

    return (
      <div style={styles.unitInfoContainer}>
        <span>{value}</span>
        <InfoIcon style={styles.infoIcon} onClick={this.handleClick} />
        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'center'
          }}
          targetOrigin={{
            horizontal: 'left',
            vertical: 'bottom'
          }}
          onRequestClose={this.handleRequestClose}
        >
          {this.renderPopoverText(unitIdAttributes)}
        </Popover>
      </div>
    );
  }
}

export default UnitId;



// WEBPACK FOOTER //
// ./src/components/common/UnitId/UnitId.js